import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import type { SchoolStatus } from '../types'

const tone = { active: 'success', invited: 'info', suspended: 'danger' } as const
const label = { active: 'Active', invited: 'Awaiting administrator', suspended: 'Suspended' } as const

export function SchoolStatusBadge({ status }: { status: SchoolStatus }) {
  const { t } = useTranslation('platform')
  return (
    <Badge tone={tone[status]} size="sm">
      {t(label[status])}
    </Badge>
  )
}
